
export const formatRupiah = (value) => {
  // Remove all non-numeric characters
  const numericValue = value.toString().replace(/\D/g, "");
  // Format with dots as thousand separators
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
 